import { render } from "./Flow.vue?vue&type=template&id=4a97b468&scoped=true&ts=true"
import script from "./Flow.vue?vue&type=script&lang=ts"
export * from "./Flow.vue?vue&type=script&lang=ts"

import "./Flow.vue?vue&type=style&index=0&id=4a97b468&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a97b468"]])

export default __exports__